import React, { useEffect, useState } from 'react';
import OwlCarousel from 'react-owl-carousel';
import axios from 'axios';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import BlogComments from './BlogComments';
import userIcon from '../../images/client-logo/user.png'
const bnr1 = require('./../../images/background/bg6.jpg');

const Testimonials = () => {
    const [comments, setComments] = useState([]);

    const options = {
        loop: true,
        autoplay: true,
        margin: 30,
        nav: false,
        dots: true,
        navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
        responsive: {
            0: {
                items: 1
            },
            991: {
                items: 2
            }
        }
    };

    useEffect(() => {
        axios.get('https://alaussback-production.up.railway.app/api/comments')
            .then(response => {
                setComments(response.data);
            })
            .catch(error => {
                console.error('Error fetching comments:', error);
            });
    }, []);

    return (
        <div className="section-full mobile-page-padding p-t80 p-b50 square_shape2 bg-cover" style={{ backgroundImage: "url(" + bnr1 + ")" }}>
            <div className="container">
                <div className="section-content">
                    <div className="section-head">
                        <div className="mt-separator-outer separator-center">
                            <div className="mt-separator">
                                <h2 className="text-uppercase sep-line-one " style={{ fontFamily: 'Cairo, sans-serif' }}>
                                    <span className="font-weight-300 text-primary" style={{ fontFamily: 'Cairo, sans-serif' }}>أراء</span> حرفائنا
                                </h2>
                            </div>
                        </div>
                    </div>
                   
                    <OwlCarousel className="owl-carousel testimonial-home" {...options}>
                        {comments.map((comment, index) => (
                            <div key={index} className="item">
                                <div className="testimonial-2 m-a30 hover-animation-1">
                                    <div className="block-shadow bg-white p-a30">
                                        <div className="testimonial-detail clearfix">
                                            <div className="testimonial-pic radius shadow scale-in-center">
                                            </div>
                                            <h4 className="testimonial-name m-b5">{comment.author}</h4>
                                            <span className="testimonial-position">{new Date(comment.createdAt).toLocaleDateString()}</span>
                                        </div>
                                        <div className="testimonial-text">
                                            <span className="fa fa-quote-right" />
                                            <p>{comment.comment}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </OwlCarousel>

                    <BlogComments />
                </div>
            </div>
        </div>
    );
};

export default Testimonials;
